"use client"

import { useEffect } from "react"
import { ErrorPage } from "@/components/errors/error-page"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <>
      <ErrorPage
        statusCode={500}
        title="Something went wrong!"
        description="An unexpected error occurred. Our team has been notified."
        showRefresh={false}
      />
      <div className="flex justify-center pb-8">
        <button
          onClick={reset}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90"
        >
          Try again
        </button>
      </div>
    </>
  )
}

